import { render } from "./HandlerCardView.vue?vue&type=template&id=282ceadc"
import script from "./HandlerCardView.vue?vue&type=script&lang=js"
export * from "./HandlerCardView.vue?vue&type=script&lang=js"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__